/**
 * This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

export interface InstantiateMsg {}
export type ExecuteMsg =
  | {
      register_tool: {
        denom?: string | null;
        description: string;
        endpoint: string;
        price: Uint128;
        tool_id: string;
      };
    }
  | {
      update_price: {
        price: Uint128;
        tool_id: string;
      };
    }
  | {
      update_denom: {
        denom: string;
        tool_id: string;
      };
    }
  | {
      update_endpoint: {
        endpoint: string;
        tool_id: string;
      };
    }
  | {
      pause_tool: {
        tool_id: string;
      };
    }
  | {
      resume_tool: {
        tool_id: string;
      };
    };
export type Uint128 = string;
export type QueryMsg =
  | {
      get_tool: {
        tool_id: string;
      };
    }
  | {
      get_tools: {};
    };
export interface ToolResponse {
  denom: string;
  description: string;
  endpoint: string;
  is_active: boolean;
  price: Uint128;
  provider: string;
  tool_id: string;
}
export interface ToolsResponse {
  tools: ToolResponse[];
}
